import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) { return }
    if (!this.hasSelectTarget) { return }

    this.maxIndex = this.selectTarget.length - 1
  }

  // Actions

  increase() {
    if (!this.hasSelectTarget) { return }

    const currentIndex = this.selectTarget.selectedIndex

    if (currentIndex >= this.maxIndex) { return }

    this.selectTarget.selectedIndex = currentIndex + 1
    this.selectTarget.dispatchEvent(new CustomEvent("change"))
  }
}
